export type IconsId =
  | 'youtube'
  | 'wishlist'
  | 'wishlist-fill'
  | 'user'
  | 'twitter'
  | 'tree'
  | 'tick'
  | 'tag'
  | 'sun'
  | 'star'
  | 'star-half'
  | 'star-empty'
  | 'snowflake'
  | 'sing-out'
  | 'share'
  | 'settings'
  | 'search2'
  | 'search'
  | 'screwdriver'
  | 'ruler'
  | 'radio-on'
  | 'radio-off'
  | 'print'
  | 'pound'
  | 'plus'
  | 'play'
  | 'pinterest'
  | 'phone3'
  | 'phone2'
  | 'phone'
  | 'payment'
  | 'pause'
  | 'minus'
  | 'menu'
  | 'login'
  | 'lock'
  | 'location'
  | 'livechat'
  | 'leaf'
  | 'instagram'
  | 'information'
  | 'info-2'
  | 'home'
  | 'help'
  | 'grid-4'
  | 'grid-4-fill'
  | 'grid-3'
  | 'grid-3-fill'
  | 'grid-2'
  | 'grid-2-fill'
  | 'grid-1'
  | 'grid-1-fill'
  | 'four'
  | 'four-circle'
  | 'flower'
  | 'flower-2'
  | 'filter'
  | 'facebook'
  | 'express'
  | 'experience'
  | 'email'
  | 'delivery'
  | 'copy'
  | 'collection'
  | 'close'
  | 'clock'
  | 'clickcollect'
  | 'chevron-up'
  | 'chevron-right'
  | 'chevron-left'
  | 'chevron-down'
  | 'chat'
  | 'card'
  | 'basket'
  | 'autumn'
  | 'arrow-up'
  | 'arrow-left'
  | 'arrow-down'
  | 'account2'
  | 'account'
  | 'account-filled';

export type IconsKey =
  | 'Youtube'
  | 'Wishlist'
  | 'WishlistFill'
  | 'User'
  | 'Twitter'
  | 'Tree'
  | 'Tick'
  | 'Tag'
  | 'Sun'
  | 'Star'
  | 'StarHalf'
  | 'StarEmpty'
  | 'Snowflake'
  | 'SingOut'
  | 'Share'
  | 'Settings'
  | 'Search2'
  | 'Search'
  | 'Screwdriver'
  | 'Ruler'
  | 'RadioOn'
  | 'RadioOff'
  | 'Print'
  | 'Pound'
  | 'Plus'
  | 'Play'
  | 'Pinterest'
  | 'Phone3'
  | 'Phone2'
  | 'Phone'
  | 'Payment'
  | 'Pause'
  | 'Minus'
  | 'Menu'
  | 'Login'
  | 'Lock'
  | 'Location'
  | 'Livechat'
  | 'Leaf'
  | 'Instagram'
  | 'Information'
  | 'Info2'
  | 'Home'
  | 'Help'
  | 'Grid4'
  | 'Grid4Fill'
  | 'Grid3'
  | 'Grid3Fill'
  | 'Grid2'
  | 'Grid2Fill'
  | 'Grid1'
  | 'Grid1Fill'
  | 'Four'
  | 'FourCircle'
  | 'Flower'
  | 'Flower2'
  | 'Filter'
  | 'Facebook'
  | 'Express'
  | 'Experience'
  | 'Email'
  | 'Delivery'
  | 'Copy'
  | 'Collection'
  | 'Close'
  | 'Clock'
  | 'Clickcollect'
  | 'ChevronUp'
  | 'ChevronRight'
  | 'ChevronLeft'
  | 'ChevronDown'
  | 'Chat'
  | 'Card'
  | 'Basket'
  | 'Autumn'
  | 'ArrowUp'
  | 'ArrowLeft'
  | 'ArrowDown'
  | 'Account2'
  | 'Account'
  | 'AccountFilled';

export enum Icons {
  Youtube = 'youtube',
  Wishlist = 'wishlist',
  WishlistFill = 'wishlist-fill',
  User = 'user',
  Twitter = 'twitter',
  Tree = 'tree',
  Tick = 'tick',
  Tag = 'tag',
  Sun = 'sun',
  Star = 'star',
  StarHalf = 'star-half',
  StarEmpty = 'star-empty',
  Snowflake = 'snowflake',
  SingOut = 'sing-out',
  Share = 'share',
  Settings = 'settings',
  Search2 = 'search2',
  Search = 'search',
  Screwdriver = 'screwdriver',
  Ruler = 'ruler',
  RadioOn = 'radio-on',
  RadioOff = 'radio-off',
  Print = 'print',
  Pound = 'pound',
  Plus = 'plus',
  Play = 'play',
  Pinterest = 'pinterest',
  Phone3 = 'phone3',
  Phone2 = 'phone2',
  Phone = 'phone',
  Payment = 'payment',
  Pause = 'pause',
  Minus = 'minus',
  Menu = 'menu',
  Login = 'login',
  Lock = 'lock',
  Location = 'location',
  Livechat = 'livechat',
  Leaf = 'leaf',
  Instagram = 'instagram',
  Information = 'information',
  Info2 = 'info-2',
  Home = 'home',
  Help = 'help',
  Grid4 = 'grid-4',
  Grid4Fill = 'grid-4-fill',
  Grid3 = 'grid-3',
  Grid3Fill = 'grid-3-fill',
  Grid2 = 'grid-2',
  Grid2Fill = 'grid-2-fill',
  Grid1 = 'grid-1',
  Grid1Fill = 'grid-1-fill',
  Four = 'four',
  FourCircle = 'four-circle',
  Flower = 'flower',
  Flower2 = 'flower-2',
  Filter = 'filter',
  Facebook = 'facebook',
  Express = 'express',
  Experience = 'experience',
  Email = 'email',
  Delivery = 'delivery',
  Copy = 'copy',
  Collection = 'collection',
  Close = 'close',
  Clock = 'clock',
  Clickcollect = 'clickcollect',
  ChevronUp = 'chevron-up',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  ChevronDown = 'chevron-down',
  Chat = 'chat',
  Card = 'card',
  Basket = 'basket',
  Autumn = 'autumn',
  ArrowUp = 'arrow-up',
  ArrowLeft = 'arrow-left',
  ArrowDown = 'arrow-down',
  Account2 = 'account2',
  Account = 'account',
  AccountFilled = 'account-filled',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Youtube]: '61697',
  [Icons.Wishlist]: '61698',
  [Icons.WishlistFill]: '61699',
  [Icons.User]: '61700',
  [Icons.Twitter]: '61701',
  [Icons.Tree]: '61702',
  [Icons.Tick]: '61703',
  [Icons.Tag]: '61704',
  [Icons.Sun]: '61705',
  [Icons.Star]: '61706',
  [Icons.StarHalf]: '61707',
  [Icons.StarEmpty]: '61708',
  [Icons.Snowflake]: '61709',
  [Icons.SingOut]: '61710',
  [Icons.Share]: '61711',
  [Icons.Settings]: '61712',
  [Icons.Search2]: '61713',
  [Icons.Search]: '61714',
  [Icons.Screwdriver]: '61715',
  [Icons.Ruler]: '61716',
  [Icons.RadioOn]: '61717',
  [Icons.RadioOff]: '61718',
  [Icons.Print]: '61719',
  [Icons.Pound]: '61720',
  [Icons.Plus]: '61721',
  [Icons.Play]: '61722',
  [Icons.Pinterest]: '61723',
  [Icons.Phone3]: '61724',
  [Icons.Phone2]: '61725',
  [Icons.Phone]: '61726',
  [Icons.Payment]: '61727',
  [Icons.Pause]: '61728',
  [Icons.Minus]: '61729',
  [Icons.Menu]: '61730',
  [Icons.Login]: '61731',
  [Icons.Lock]: '61732',
  [Icons.Location]: '61733',
  [Icons.Livechat]: '61734',
  [Icons.Leaf]: '61735',
  [Icons.Instagram]: '61736',
  [Icons.Information]: '61737',
  [Icons.Info2]: '61738',
  [Icons.Home]: '61739',
  [Icons.Help]: '61740',
  [Icons.Grid4]: '61741',
  [Icons.Grid4Fill]: '61742',
  [Icons.Grid3]: '61743',
  [Icons.Grid3Fill]: '61744',
  [Icons.Grid2]: '61745',
  [Icons.Grid2Fill]: '61746',
  [Icons.Grid1]: '61747',
  [Icons.Grid1Fill]: '61748',
  [Icons.Four]: '61749',
  [Icons.FourCircle]: '61750',
  [Icons.Flower]: '61751',
  [Icons.Flower2]: '61752',
  [Icons.Filter]: '61753',
  [Icons.Facebook]: '61754',
  [Icons.Express]: '61755',
  [Icons.Experience]: '61756',
  [Icons.Email]: '61757',
  [Icons.Delivery]: '61758',
  [Icons.Copy]: '61759',
  [Icons.Collection]: '61760',
  [Icons.Close]: '61761',
  [Icons.Clock]: '61762',
  [Icons.Clickcollect]: '61763',
  [Icons.ChevronUp]: '61764',
  [Icons.ChevronRight]: '61765',
  [Icons.ChevronLeft]: '61766',
  [Icons.ChevronDown]: '61767',
  [Icons.Chat]: '61768',
  [Icons.Card]: '61769',
  [Icons.Basket]: '61770',
  [Icons.Autumn]: '61771',
  [Icons.ArrowUp]: '61772',
  [Icons.ArrowLeft]: '61773',
  [Icons.ArrowDown]: '61774',
  [Icons.Account2]: '61775',
  [Icons.Account]: '61776',
  [Icons.AccountFilled]: '61777',
};
